import React, { useEffect } from "react";
import { connect } from "react-redux";

import { fetchAuditors } from "../../actions/users";
import { fetchStandards, fetchStandardScopes } from "../../actions/standards";
import AuditorTable from "../../components/Users/AuditorTable";

export function ScheduleMatrix(props) {
  useEffect(() => {
    props.fetchAuditors(props.accessToken);
    props.fetchStandards("?limit=1000", props.accessToken);
  }, []); // eslint-disable-line

  function handleChangeStandard(id) {
    return props.fetchStandardScopes(id, props.accessToken);
  }

  return (
    <div className="content">
      <div>
        <div className="main-header">
          <h2>Auditor & Experts List</h2>
        </div>
        <div className="row">
          <div className="col-md-12">
            {props.auditors && props.standards ? (
              <AuditorTable
                role={props.role}
                auditors={props.auditors}
                standards={props.standards}
                scopes={props.scopes}
                onChangeStandard={handleChangeStandard}
              />
            ) : (
              <div>loading</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    auditors: state.users.auditorList.data,
    standards: state.standards.standardList.data,
    accessToken: state.auth.user.access.access_token,
    role: state.auth.user.data.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAuditors: (key) => dispatch(fetchAuditors(key)),
    fetchStandards: (params, key) => dispatch(fetchStandards(params, key)),
    fetchStandardScopes: (id, key) => dispatch(fetchStandardScopes(id, key)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleMatrix);
